<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <ThanksVue />
      <v-row align="center" justify="center">
        <v-card max-width="75%" flat color="background">
          <v-row class="d-flex">
            <h1 class="mb-4">Califica tu servicio</h1>
          </v-row>

          <v-row align="center" justify="center">
            <v-col>
              <v-row class="d-flex align-center justify-start">
                <h2>Tu recarga por:</h2>
              </v-row>
            </v-col>
            <v-col>
              <v-row class="d-flex align-center justify-end">
                <h2>${{ qualifyData.amount }}</h2>
              </v-row>
            </v-col>
          </v-row>

          <v-row class="mb-6" align="center" justify="center">
            <v-col class="ma-2">
              <v-row align="center" justify="center">
                <v-img
                  :src="qualifyData.evidence.before.photo"
                  class="foto"
                  max-height="200"
                  max-width="300"
                ></v-img>
              </v-row>
            </v-col>
            <v-col class="ma-2">
              <v-row align="center" justify="center">
                <v-img
                  :src="qualifyData.evidence.after.photo"
                  class="foto"
                  max-height="200"
                  max-width="300"
                ></v-img>
              </v-row>
            </v-col>
          </v-row>

          <v-row class="d-flex mt-6">
            <h2 class="mb-4">Tu repartidor</h2>
          </v-row>

          <v-row align="center" justify="center">
            <v-col>
              <v-row align="center" justify="center">
                <v-avatar size="80">
                  <img :src="qualifyData.provider.urlPhoto" />
                </v-avatar>
              </v-row>
            </v-col>
            <v-col>
              <v-row align="center" justify="start">
                <h3>{{ qualifyData.provider.shortName }}</h3>
              </v-row>
              <v-row align="center" justify="start">
                <p>
                  <b>Asistente:</b> {{ qualifyData.provider.assistantName }}
                </p>
              </v-row>
              <v-row align="center" justify="start">
                <p><b>Compañia:</b> {{ qualifyData.provider.company.name }}</p>
              </v-row>
              <v-row align="center" justify="start">
                <p>
                  <b>Precio:</b> ${{
                    qualifyData.provider.company.pricePerLiter
                  }}
                  Litro
                </p>
              </v-row>
            </v-col>
          </v-row>
          

          <v-row align="center" justify="center">
            <p>¿Cómo estuvo tu servicio?</p>
          </v-row>

          <v-row align="center" justify="center" class="mb-3">
            <v-rating
              v-model="puntuacion"
              color="primary"
              dense
              size="40"
            ></v-rating>
          </v-row>

          <v-row align="center" justify="center">
            <p>¿Cómo podemos mejorar?</p>
          </v-row>

          <v-row align="center" justify="center">
            <v-textarea
              v-model="comentarios"
              outlined
              placeholder="Dejanos tu comentario."
            ></v-textarea>
          </v-row>

          <v-row>
            <v-btn class="mb-6 buttonPrimary" block @click="sendComments()"
              >Enviar comentarios</v-btn
            >
          </v-row>
        </v-card>
      </v-row>
      <v-row align="center" justify="center"></v-row>
    </v-row>
  </v-container>
</template>

<script>
import Axios from "axios";
import { mapFields } from "vuex-map-fields";
import ThanksVue from "../components/Thanks.vue";
import config from "../config"

export default {
  computed: {
    ...mapFields([
      "seguirServicioNumberUuid",
      "thanksModal",
      "loader",
      "showMessage",
      "message",
    ]),
  },
  components: {
    ThanksVue,
  },
  data() {
    return {
      qualifyData: {},
      comentarios: "",
      puntuacion: 0,
    };
  },
  methods: {
    sendComments() {
      if (this.puntuacion === 0) {
        this.message = "Selecciona la puntuación de tu servicio.";
        this.showMessage = true;
      } else {
        this.loader = true;
        let api = Axios.post(config.apiBaseUrl + "/provider/service/score", 
        {
          serviceUuid: this.seguirServicioNumberUuid,
          score: this.puntuacion.toString(),
          comment: this.comentarios,
        }, 
        {
          headers: {
            "x-api-key": config.apiKey,
          },
        })
          .then((response) => {
            this.loader = false;
            this.thanksModal = true;
          })
          .catch((error) => {
            this.loader = false;
            this.message = "Ocurrió un error.";
            this.showMessage = true;
            console.error(error);
          });
      }
    },
    async getServices() {
      this.loader = true;
      let api = Axios.get(
        config.apiBaseUrl + "/services/detail-customer/" + this.seguirServicioNumberUuid,
        {
          headers: {
            "x-api-key": config.apiKey,
          },
        }
      )
        .then((response) => {
          this.loader = false;
          this.qualifyData = response.data;
        })
        .catch((error) => {
          this.loader = false;
          console.error(error);
        });
    },
  },
  mounted() {
    if (this.seguirServicioNumberUuid) {
      this.getServices();
    } else {
      this.$router.push({ name: "Home" });
    }
  },
};
</script>

<style scoped>
.foto {
  border-radius: 5%;
}
</style>